import qs from 'qs';

import type { AppRoute } from '@/constants/routes';

export type RouteDestination = {
  route: AppRoute;
  searchParams?: Record<string, unknown>;
};

export const withQueryParams = (path: AppRoute, query?: Record<string, unknown>): string => {
  if (!query || Object.keys(query).length === 0) {
    return path;
  }

  const q = qs.stringify(query, { encode: true, arrayFormat: 'indices' });

  return `${path}?${q}`;
};
